<template>
  <v-col class="participant-video participant-video--self mt-2">
    <div class="item-card">
      <div class="video-wrapper" ref="video">
        <video ref="videoElement" autoplay playsinline></video>
        <div class="self-video-placeholder" v-if="!hasVideo">
          <room-avatar />
        </div>
      </div>
      <content-line text="You">
        <template #actions>
          <v-btn small fab icon @click="$emit('openSettings')">
            <v-icon>settings</v-icon>
          </v-btn>
        </template>
      </content-line>
    </div>
  </v-col>
</template>

<script>
import { mapState } from 'vuex';
import RoomAvatar from '@/components/rooms/components/RoomAvatar.vue';

export default {
  name: 'RoomSelfFeed',
  components: {
    RoomAvatar,
  },
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasVideo: false,
      localVideoTrack: null,
    };
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
  },
  watch: {
    room: {
      immediate: true,
      handler(room) {
        if (room) {
          this.attachLocalVideoTrack();
        } else {
          this.removeLocalVideoTrack();
        }
      },
    },
  },
  beforeDestroy() {
    this.removeLocalVideoTrack();
  },
  methods: {
    async attachLocalVideoTrack() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { width: 640, height: 480 },
          audio: true,
        });

        const videoElement = this.$refs.videoElement;
        if (videoElement) {
          videoElement.srcObject = stream;
          this.localVideoTrack = stream.getVideoTracks()[0];
          this.hasVideo = true;
        }
      } catch (error) {
        console.error('Error accessing media devices:', error);
        this.hasVideo = false;
      }
    },
    removeLocalVideoTrack() {
      if (this.localVideoTrack) {
        this.localVideoTrack.stop();
        this.localVideoTrack = null;
      }
      const videoElement = this.$refs.videoElement;
      if (videoElement) {
        videoElement.srcObject = null;
      }
      this.hasVideo = false;
    },
  },
};
</script>

<style lang="less">
.participant-video--self {
  .content-line {
    background: rgba(27, 192, 175, 0.8);
    height: 50px;
  }
}
</style>
